import React, { useState, useRef } from 'react';
import { UploadCloud, FileAudio, FileImage, FileText, Loader2 } from 'lucide-react';
import { uploadAsset } from '../services/assets';

export default function MediaLibrary() {
  const [isUploading, setIsUploading] = useState(false);
  const [assets, setAssets] = useState<any[]>([]); // سيتم جلب الأصول المخزنة لاحقاً
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setIsUploading(true);
    try {
      const token = localStorage.getItem('jwt_token') || ''; 
      const data = await uploadAsset(file, token);
      
      // إضافة الملف المرفوع حديثاً إلى الواجهة
      setAssets(prev => [data.asset, ...prev]);
      alert('تم رفع الملف بنجاح!');
    } catch (error: any) {
      alert(error.message);
    } finally {
      setIsUploading(false);
      if (fileInputRef.current) fileInputRef.current.value = '';
    }
  };

  const getAssetIcon = (type: string) => {
    switch (type) {
      case 'audio': return <FileAudio className="w-8 h-8 text-blue-500" />;
      case 'image': return <FileImage className="w-8 h-8 text-emerald-500" />;
      case 'subtitle': return <FileText className="w-8 h-8 text-amber-500" />;
      default: return <FileText className="w-8 h-8 text-slate-500" />;
    }
  };

  return (
    <div className="p-8 max-w-6xl mx-auto">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-2xl font-bold text-slate-800">مكتبة الوسائط (DAM)</h1>
        
        <div>
          <input 
            type="file" 
            ref={fileInputRef} 
            onChange={handleFileUpload} 
            className="hidden" 
            accept="image/*,audio/*,video/*,.vtt,.srt"
          />
          <button 
            onClick={() => fileInputRef.current?.click()}
            disabled={isUploading}
            className="bg-slate-900 text-white px-4 py-2 rounded-md flex items-center gap-2 hover:bg-slate-800 transition-colors disabled:opacity-50"
          >
            {isUploading ? <Loader2 className="animate-spin w-5 h-5" /> : <UploadCloud className="w-5 h-5" />}
            <span>{isUploading ? 'جاري الرفع...' : 'رفع ملف جديد'}</span>
          </button>
        </div>
      </div>

      {/* شبكة عرض الملفات */}
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4">
        {assets.map((asset) => (
          <div key={asset.uuid} className="border border-slate-200 rounded-lg p-4 flex flex-col items-center justify-center gap-3 bg-white hover:shadow-sm transition-shadow cursor-pointer">
            {getAssetIcon(asset.type)}
            <span className="text-sm text-slate-600 text-center truncate w-full" title={asset.filename}>
              {asset.filename}
            </span>
          </div>
        ))}
        {assets.length === 0 && !isUploading && (
          <div className="col-span-full py-12 text-center text-slate-400 border-2 border-dashed border-slate-200 rounded-lg">
            لا توجد ملفات حالياً. ابدأ برفع أول أصل رقمي.
          </div>
        )}
      </div>
    </div>
  );
}